<template>
  <b-modal
    ref="classSchModal"
    hide-footer
    title="Enter Days to Exclude from Schedule"
    centered
    lazy
    size="lg"
    @hide="hideModal"
  >
    <b-form @submit.prevent="onSave">
      <b-form-group>
        <label class="form-label">
          Days to Exclude
          <i
            class="material-icons icon-16pt clickable-item text-muted"
            v-b-popover.hover.top="
              `Select days to exclude from auto-generated schedule, leaving this field empty will generate schedule on each day from start to end date.`
            "
            >info</i
          >
        </label>
        <v-select
          id="day"
          class="form-control v-select-custom"
          label="text"
          style="width: 100%"
          v-model="day"
          :reduce="(item) => item.value"
          :options="dayOptions"
          multiple
          placeholder="Select days to exclude from schedule"
        >
        </v-select>
      </b-form-group>
      <b-form-group
        label="Self Paced Days"
        label-for="selfPacedDays"
        label-class="form-label"
        v-if="['virtual', 'blended'].includes(this.type)"
      >
        <b-form-input id="selfPacedDays" v-model="selfPace" type="number" placeholder="Enter self paced days" />
      </b-form-group>

      <b-btn
        variant="primary"
        style="width: 200px"
        type="submit"
        class="btn-normal d-flex ml-auto"
        :disabled="isLoading"
      >
        <i v-if="isLoading" class="fas fa-circle-notch fa-spin"></i>
        <span v-else> Generate</span>
      </b-btn>
    </b-form>
  </b-modal>
</template>

<script>
import { get } from 'lodash';
import vSelect from 'vue-select';
export default {
  name: 'AutoGenModal',
  components: {
    vSelect,
  },

  props: {
    showModal: { type: Boolean, default: false },
    type: { type: String, default: '' },
    selfPacedDays: { type: Number, default: 0 },
  },

  data() {
    return {
      day: [],
      dayOptions: [
        { text: 'Sunday', value: 0 },
        { text: 'Monday', value: 1 },
        { text: 'Tuesday', value: 2 },
        { text: 'Wednesday', value: 3 },
        { text: 'Thursday', value: 4 },
        { text: 'Friday', value: 5 },
        { text: 'Saturday', value: 6 },
      ],

      modalTitle: '',
      selfPace: null,
      isLoading: false,
    };
  },

  computed: {},

  watch: {
    showModal(value) {
      if (value) {
        this.$refs.classSchModal.show();
        this.selfPace = this.selfPacedDays;
      } else {
        this.day = [];
        this.selfPace = 0;
        this.$refs.classSchModal.hide();
      }
    },
  },

  methods: {
    get,

    hideModal() {
      this.$refs.classSchModal.hide();
      this.$emit('close');
    },

    hideUpdateModal() {
      this.$emit('closeUpdate', { day: this.day, self: parseInt(this.selfPace) });
    },

    hideModalManual() {
      this.hideModal();
    },

    onSave() {
      this.hideUpdateModal();
    },
  },

  async mounted() {},
};
</script>
